import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { ClientDetails } from '../../feature-modules/profile/models/profile';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EditAccountService {

  constructor(private apiService: ApiService, private http: HttpClient) {}

  updateProfile(body: ClientDetails): Observable<ApiResponse<ClientDetails>> {
    return this.apiService.post<ClientDetails, ApiResponse<ClientDetails>>(
      '/client/Update',
      body
    );
  }

  uploadImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('ImagesFolder', 'clients');
    formData.append('Files', file);

    const headers = new HttpHeaders({
      'Accept': 'application/json, text/plain, */*',
    });

    return this.http.post(environment.uploadImageUrl, formData, { headers });
  }

}
